import { uppercaseFirstLetter } from './';

export const slugToVariableName = (slug) => {
  // remove all spaces and non-alphanumeric characters from slub
  const slugParts = slug.split('-');
  return slugParts.map((part, i) => i === 0 ? part : uppercaseFirstLetter(part)).join('');
};
